var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tree',{attrs:{"props":_vm.props,"load":_vm.loadNode,"lazy":"","accordion":""},on:{"node-click":_vm.nodeClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }